import {derived, writable} from 'svelte/store';
import {sortCompareDESC} from "../../../../../lib/utils";

const I_MIN = 0;
let I = I_MIN;
const resetI = () => I = I_MIN;
const incrI = () => I++;

const COLOUR = {
    default: 'default',
    slate: 'slate',
    gray: 'gray',
    zinc: 'zinc',
    neutral: 'neutral',
    stone: 'stone',
    red: 'red',
    orange: 'orange',
    amber: 'amber',
    yellow: 'yellow',
    lime: 'lime',
    green: 'green',
    emerald: 'emerald',
    teal: 'teal',
    cyan: 'cyan',
    sky: 'sky',
    blue: 'blue',
    indigo: 'indigo',
    violet: 'violet',
    purple: 'purple',
    fuchsia: 'fuchsia',
    pink: 'pink',
    rose: 'rose',
}

export const I_PEOPLE_TAG = {
    ID: incrI(),          // (up to) Three Letter Acronym (TLA) used as a unique ID for the tag
    NAME: incrI(),        // Display name for the tag, keep it short, can use 'category:specific' to group tags, only 'specific' will be used
    DESCRIPTION: incrI(), // Textual description of the tag, mainly used in search, so keep it keyword rich
    BG_COLOUR: incrI(),   // (Optional) tailwind colour to use for tag background, e.g. 'indigo-500', if not used then tag will display with default colour
    TEXT_COLOUR: incrI(), // (Optional) tailwind colour to use for tag text, e.g. 'indigo-500', if not used then tag will display with default colour
    DELETED: incrI(),     // false|true - true = won't be displayed or used, but kept around so ID/TLA doesn't cause issues
};

// **WARNING** don't delete a tag, set the deleted field to 'true' (the last element)
// NB every time you add a colour that hasn't been used before in this list, you will need to add it to the comment in Tag.svelte!
const PEOPLE_TAG_LIST = [
    ['VIP', 'EVIP', 'target person for promotions, prospect, UHNW', COLOUR.sky, COLOUR.sky, false],

    ['MS', 'marital:single', 'unmarried, no partner', COLOUR.rose, COLOUR.rose, false],
    ['MR', 'marital:relationship', 'unmarried, in a relationship, has a partner', COLOUR.rose, COLOUR.rose, false],
    ['MM', 'marital:married', 'married, has a partner', COLOUR.rose, COLOUR.rose, false],
    ['MD', 'marital:divorced', 'divorced from a previous partner', COLOUR.rose, COLOUR.rose, false],

    ['KK', 'kids:kids', 'has kids, children', COLOUR.default, COLOUR.default, false],
    ['KY', 'kids:young-kids', 'has young kids, school age children', COLOUR.default, COLOUR.default, false],
    ['KA', 'kids:adult-kids', 'has adult kids, grown children', COLOUR.default, COLOUR.default, false],
    ['KN', 'kids:no-kids', `doesn't have kids, no kids, no children`, COLOUR.default, COLOUR.default, false],

    ['GM', 'gender:male', `man`, COLOUR.blue, COLOUR.blue, false],
    ['GW', 'gender:female', `woman`, COLOUR.pink, COLOUR.pink, false],

    ['A2', 'age:20s', `twenty-something`, COLOUR.default, COLOUR.default, false],
    ['A3', 'age:30s', `thirty-something`, COLOUR.default, COLOUR.default, false],
    ['A4', 'age:40s', `forty-something`, COLOUR.default, COLOUR.default, false],
    ['A5', 'age:50s', `fifty-something`, COLOUR.default, COLOUR.default, false],
    ['A6', 'age:60s', `sixty-something`, COLOUR.default, COLOUR.default, false],
    ['A7', 'age:70+', `seventy plus, elderly, retired`, COLOUR.default, COLOUR.default, false],

    ['CW', 'comms:WhatsApp', `prefers WhatsApp for communicating`, COLOUR.lime, COLOUR.lime, false],
    ['CI', 'comms:iMessage', `prefers iMessage for communicating`, COLOUR.blue, COLOUR.blue, false],
    ['CS', 'comms:SMS', `prefers SMS/Texting for communicating`, COLOUR.green, COLOUR.green, false],
    ['CE', 'comms:email', `prefers Email for communicating`, COLOUR.stone, COLOUR.stone, false],

    // income level/net worth
    // profession
    // geographic location

    // ['', '', ``, COLOUR.default, COLOUR.default, false],
];

const _createLookup = list => {
    let result = {};
    for(let i = 0, n = list.length; i < n; i++) {
        if(result[list[i][I_PEOPLE_TAG.ID]] !== undefined) throw new Error(`Collision found with tag ID TLA - change TLA for most recently added tag with the TLA: ${list[i][I_PEOPLE_TAG.ID]}`);
        result[list[i][I_PEOPLE_TAG.ID]] = list[i];
    }
    return result;
};

export const people_tags = writable({
    list: PEOPLE_TAG_LIST,
    lookup: _createLookup(PEOPLE_TAG_LIST),
});

export const people_tags_search_list = derived(people_tags, $people_tags => {
    let result = [];
    let item;
    for(let i = 0, n = $people_tags.list.length; i < n; i++) {
        item = $people_tags.list[i];
        if(item[I_PEOPLE_TAG.DELETED]) continue;
        result.push([`${item[I_PEOPLE_TAG.NAME]} ${item[I_PEOPLE_TAG.DESCRIPTION]}`.toLowerCase(), item[I_PEOPLE_TAG.ID]]);
    }
    return result;
}, []);

